import { getLocale } from "../runtime";

const sv_eucountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Europe`
};

const eucountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_eucountryenglish(inputs)
	return "euCountryEnglish";
};

export { eucountryenglish as "euCountryEnglish" };